import React, { useState } from "react";
import LeaveTable from "./components/LeaveTable";
import { connect } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { ClipboardList, FilePlusCorner, Plane, ScanHeart, UserLock,  } from "lucide-react";
import LeaveForm from "./components/LeaveForm";
import PopupButton from "components/button/PopupButton";
import { MODULE_LEAVE, DATE_FORMAT } from "variables/constants";
import { DatePicker } from "antd";

const { RangePicker } = DatePicker;

const Leaves = () => {
	const [dateRange, setDateRange] = useState(null);

	return (
	    <div className="space-y-6">
			<SummaryHeader
				title="Leave History"
				icon={ClipboardList}
				description="View your past and pending leave requests"
				color={"cyan"}
        		rightNav={
							<PopupButton 
								id="add_leave" 
								title="Request Leave"
								description="Submit a new leave request"
								label="Request Leave" 
								btnClass="btn-leave" 
								action="add"
								moduleId={MODULE_LEAVE}
								icon={FilePlusCorner}
								useCustomClass={true}
							>
								<LeaveForm recordId="0" mode="edit"/>
							</PopupButton>
				}
			>
                    <div className="summary-item-container">
                        <SummaryItem
                            title="Vacation Days"
                            icon={<Plane />}
                            display={      
									<div className="flex items-center gap-2">
										<p className="text-xl font-bold">0</p>
										<p className="text-xs">of 15 remaining</p>
									</div>
							}
                        />
                        <SummaryItem
                            title="Sick Days"
                            icon={<ScanHeart />}
                            display={      
									<div className="flex items-center gap-2">
										<p className="text-xl font-bold">0</p>
										<p className="text-xs">of 5 remaining</p>
									</div>
							}
                        />
                        <SummaryItem
                            title="Personal Days"
                            icon={<UserLock />}
                            display={      
									<div className="flex items-center gap-2">
										<p className="text-xl font-bold">0</p>
										<p className="text-xs">of 5 remaining</p>
									</div>
							}
                        />
                    </div>
			</SummaryHeader>
			<div className="mt-5 flex justify-start w-1/2">
				<RangePicker
					format={DATE_FORMAT}
					onChange={(dates) => setDateRange(dates)}
					className="input-field"
					allowClear
				/>
			</div>
			<div className="p-4 border rounded-xl">
				<LeaveTable dateRange={dateRange}/>
			</div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Leaves);